/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Key_User_UpdateInputs */

const cs_audit_key_user_update = /** @type {(inputs: Audit_Key_User_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uživatel upraven`)
};

const en_audit_key_user_update = /** @type {(inputs: Audit_Key_User_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User updated`)
};

/**
* | output |
* | --- |
* | "User updated" |
*
* @param {Audit_Key_User_UpdateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_key_user_update = /** @type {((inputs?: Audit_Key_User_UpdateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Key_User_UpdateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_key_user_update(inputs)
	return cs_audit_key_user_update(inputs)
});